import React, { useState } from 'react';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [submitStatus, setSubmitStatus] = useState('idle'); // idle, submitting, success, error

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitStatus('submitting');

        try {
            const response = await fetch('https://formspree.io/f/xqarlyzz', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setSubmitStatus('success');
                setFormData({ name: '', email: '', subject: '', message: '' }); // Reset form
            } else {
                setSubmitStatus('error');
            }
        } catch (error) {
            setSubmitStatus('error');
        }
    };

    return (
        <div className="contact-section">
            <div className="container">
                <div className="text-center" style={{ marginBottom: '60px' }}>
                    <h1>CONTACTEZ-MOI</h1>
                    <p className="max-w-800">
                        Vous avez une question, souhaitez organiser une formation,
                        ou obtenir un devis personnalisé ? N’hésitez pas à me contacter.
                    </p>
                </div>

                <div className="contact-container-grid">
                    <div className="contact-info-card text-left">
                        <h2>Discutons de votre projet</h2>
                        <p>
                            Que ce soit pour une formation en entreprise, une sensibilisation en milieu scolaire ou une intervention sur mesure, je suis à votre écoute pour construire ensemble la solution adaptée à vos besoins.
                        </p>
                        <div style={{ marginTop: '40px' }}>
                            <h4 style={{ marginBottom: '10px', color: 'var(--primary-color)' }}>Téléphone</h4>
                            <p style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>06 11 03 93 84</p>

                            <h4 style={{ marginBottom: '10px', color: 'var(--primary-color)', marginTop: '30px' }}>Email</h4>
                            <p style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>cathy@helpmindformation.fr</p>
                        </div>
                    </div>

                    <div className="contact-form-card">
                        <h3 style={{ marginBottom: '30px', textAlign: 'center' }}>Envoyez-moi un message</h3>

                        {submitStatus === 'success' ? (
                            <div className="msg-success">
                                <h4>Message envoyé avec succès !</h4>
                                <p>Merci de m'avoir contacté. Je vous répondrai dans les plus brefs délais.</p>
                                <button className="btn btn-sm" onClick={() => setSubmitStatus('idle')} style={{ marginTop: '15px', background: 'white', color: 'var(--accent-color)' }}>Envoyer un autre message</button>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name">Nom complet</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-input"
                                        placeholder="Votre nom"
                                        required
                                        value={formData.name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Votre adresse mail</label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="form-input"
                                        placeholder="exemple@mail.com"
                                        required
                                        value={formData.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="subject">Objet</label>
                                    <input
                                        type="text"
                                        id="subject"
                                        name="subject"
                                        className="form-input"
                                        placeholder="Demande de formation, information..."
                                        required
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="message">Votre message</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        className="form-textarea"
                                        placeholder="Écrivez votre message ici..."
                                        required
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>

                                {submitStatus === 'error' && (
                                    <div className="msg-error" style={{ marginBottom: '20px' }}>
                                        Une erreur est survenue lors de l'envoi. Veuillez réessayer ou me contacter directement par email.
                                    </div>
                                )}

                                <button type="submit" className="submit-btn" disabled={submitStatus === 'submitting'}>
                                    {submitStatus === 'submitting' ? 'Envoi en cours...' : 'Envoyer'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
